export const LOAD_FEATURE_FLAGS = 'LOAD_FEATURE_FLAGS';

export interface FeatureFlagsState {
	workListV2: boolean;
	saveSowLogging: boolean;
	userManagement: boolean;
	createSite: boolean;
	quickSearch: boolean;
	siteMigration: boolean;
}
